import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconSend: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.29716 14.4989H9.25067C8.89998 14.4777 8.60739 14.2228 8.53777 13.8777L7.34443 7.9988C7.28235 7.69371 7.04444 7.45527 6.74002 7.39305L0.87409 6.19709C0.454328 6.11354 0.181626 5.70477 0.264993 5.28409C0.319316 5.00997 0.516418 4.78624 0.781103 4.69826L13.1794 0.558988C13.5749 0.395295 14.028 0.583973 14.1913 0.980411C14.2656 1.16065 14.2695 1.36229 14.2022 1.54527L10.0721 13.9708C9.96125 14.3012 9.64443 14.5171 9.29716 14.4989L9.29716 14.4989Z"
        fill="white"
      />
    </svg>
  </IconStyled>
);

IconSend.defaultProps = iconDefaultProps;
IconSend.displayName = 'IconSend';

export default IconSend;
